import * as Yup from 'yup';
import { emailRegex } from '@pharmaplan/common';
import { nameRegex, phoneRegex } from '../../../../helpers/Constants';
import strings from '../../../../localization';
import { taxNumberValidation } from '../../../../helpers/commonValidators';

const hourlyRateValidator = Yup.number()
  .typeError(strings.mustBeNumber)
  .moreThan(
    0,
    strings.formatString(strings.pleaseEnterMoreThan, '0') as string,
  )
  .max(
    999.99,
    strings.formatString(strings.pleaseEnterLessThan, '1000') as string,
  );

export const adminConfigurationValidator = () =>
  Yup.object().shape({
    representativeName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName),
    representativeEmail: Yup.string()
      .required(strings.requiredField)
      .matches(emailRegex, strings.emailValid),
    representativePhone: Yup.string()
      .required(strings.requiredField)
      .max(
        12,
        strings.formatString(strings.phoneValidation, strings.phone) as string,
      )
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.phone) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`),
    ratePharmacistDays: Yup.number()
      .required(strings.requiredField)
      .typeError(strings.mustBeNumber),
    minHourWorkshift: Yup.number()
      .required(strings.requiredField)
      .typeError(strings.mustBeNumber),
    pharmacistRate: hourlyRateValidator.nullable(),
    pharmacistWeekDayHourlyRate: hourlyRateValidator.nullable(),
    pharmacistWeekendHourlyRate: hourlyRateValidator.nullable(),
    technicianRate: hourlyRateValidator.nullable(),
    technicianWeekDayHourlyRate: hourlyRateValidator.nullable(),
    technicianWeekendHourlyRate: hourlyRateValidator.nullable(),
    studentRate: hourlyRateValidator.nullable(),
    studentWeekDayHourlyRate: hourlyRateValidator.nullable(),
    studentWeekendHourlyRate: hourlyRateValidator.nullable(),
    tpsNumber: taxNumberValidation,
    tvqNumber: taxNumberValidation,
  });
